import React, { useEffect } from 'react'
import AchievementList from '../components/AchievementList'

const Achievements = () => {

    useEffect(() => {
        document.title = 'Arya Rizky Tri Putra - Achievements'
    }, []);

    return <section className='text-light container mx-auto pb-32  mt-24 md:h-screen px-5'>
        <h3 className='font-black md:text-3xl text-2xl mb-10 text-center'>My Amazing Achievements🎯</h3>
        <ol class="items-center sm:flex justify-center md:mb-20">
            <AchievementList title="1st Winner of Dinacom 2022" date="March 2022" link="https://drive.google.com/file/d/1_m9VQw4UqOdW_7qspS6FsQm39PrBj2ZO/view?usp=sharing" />
            <AchievementList title="1st Winner of LKS Wilker 1" date="January 2022" link="https://drive.google.com/file/d/11267DOyuUW7m_4jjmg64sNV7TS0w2xsj/view?usp=sharing" />
            <AchievementList title="1st Winner of Indonesian Programming Olympiad" date="April 2021" link="https://drive.google.com/file/d/1wU46l4_GXZmNnI5IBcP2XZ2SQuqaHQv3/view?usp=sharing" />
        </ol>

        <ol class="items-center sm:flex justify-center">
            <AchievementList title="3rd Winner of Web Design Competition" date="Juli 2021" link="https://drive.google.com/file/d/13XgUtzJ3tvRtZ0rGerdviZnaYVS7gB6J/view?usp=sharing" />
            <AchievementList title="1st Winner of Dinacom 2021" date="April 2021" link="https://drive.google.com/file/d/1kO3KUGKsGmXcpbqtQBNECBMCzP9AI1wI/view?usp=sharing" />
        </ol>

    </section>
}

export default Achievements
